module.exports = __webpack_public_path__ + "img/yufa.b88e04ac.png";